import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@store';

/**
 * Base selector for classification state
 */
const selectClassificationState = (state: RootState) => state.classification;

/**
 * Selector for classification loading state
 */
export const selectClassificationLoading = createSelector(selectClassificationState, state => state.isLoading);

/**
 * Selector for file uploading state
 */
export const selectFileUploading = createSelector(selectClassificationState, state => state.isFileUploading);

/**
 * Selector for classification errors state
 */
export const selectClassificationError = createSelector(selectClassificationState, state => state.errors);

/**
 * Selector for classification result for a specific community (most recent)
 */
export const selectCommunityClassificationResult = (communityId: string) =>
  createSelector(selectClassificationState, state => {
    const results = state.classificationResults[communityId] || [];

    return results.length > 0 ? results[0] : null;
  });

/**
 * Selector for classification result history for a specific community
 */
export const selectCommunityResultHistory = (communityId: string) =>
  createSelector(selectClassificationState, state => state.classificationResults[communityId] || []);
